import { AppConfig } from "app.config";
import { GenericRequest } from "data-layer/types";

export const ProcessPaymentService = (data: Record<string, {} | string>): GenericRequest => ({
  url: AppConfig.payUrl!,
  method: AppConfig.useDummyData ? 'GET' : 'POST',
  data,
});

export const ProcessPaymentServiceV2 = (data: Record<string, {} | string>): GenericRequest => ({
  url: AppConfig.payUrl_v2!,
  method: AppConfig.useDummyData ? 'GET' : 'POST',
  data,
});
